import * as yup from 'yup';

/** Validates search form fields; must match Flow Definitions search schema (search.json). */
const validationSchema = () =>
  yup.object().shape({
    name: yup.string().nullable(),
  });

export default validationSchema;
